import { isLocked, isHidden } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { getUnlockBadge } from "app/components/SideBar/getUnlockBadge";
import { translate } from "app/filters/i18nFilter";
import type { IIndustryNavItems } from "app/pages/digital-suite/config/navigation/industryResearchNavObj";
import { applyNavItemPermissions } from "app/pages/workspace/common/workspacesUtils";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { CategoryServiceUtils } from "app/services/CategoryServiceUtils";
import { BasicDurations } from "app/services/DurationService";

const navClaims = (getComponent: () => Parameters<typeof isLocked>[0]) => ({
    get lockIcon() {
        return isLocked(getComponent());
    },
    get hidden() {
        return isHidden(getComponent());
    },
});

const getWebMarketAnalysisGroup = (): IIndustryNavItems => [
    {
        name: "rankings",
        title: translate("industryAnalysis.rankings.title"),
        isOpen: true,
        hidden: false,
        subItems: [
            {
                title: "sidebar.market.analysis.web.overview.mapping.title.market",
                name: "mapping",
                state: "digitalsuite_marketresearch_webmarketanalysis_mapping",
                ...navClaims(() => swSettings.components.IATopWebsitesExtended),
            },
            {
                title: "industryanalysis.categoryLeaders.CategoryLeaders.title",
                name: "Search",
                ...navClaims(() => swSettings.components.CategoryLeaders),
                customClass: "pull-childs-left",
                state: "digitalsuite_marketresearch_webmarketanalysis_rankings",
                overrideParams: {
                    duration: BasicDurations.LAST_MONTH,
                },
                reloadOnSearch: true,
                upsellBadgeComponent: isLocked(swSettings.components.CategoryLeaders) ? getUnlockBadge() : undefined,
            },
        ],
    },
];

const navFilter = (item) => (item.customFilter ? item.customFilter() : true);

export const industryAnalysisNavObj31 = (): { navList: IIndustryNavItems } => {
    const navItems = getWebMarketAnalysisGroup()
        .filter(navFilter)
        .map((navItem) => {
            if (!navItem.subItems) {
                return navItem;
            }
            const { subItems = [] } = navItem;
            const filteredSubItems = subItems.filter(navFilter);
            return { ...navItem, subItems: filteredSubItems };
        });
    const params = proNavigator.getParams();
    const { category } = params;
    const selectedCustomIndustryHasSegments = category ? CategoryServiceUtils.selectedCategoryHasSegments() : null;
    const navItemGroups = selectedCustomIndustryHasSegments
        ? navItems.filter(({ supportSegment }) => supportSegment)
        : navItems;
    return {
        navList: navItemGroups.map(applyNavItemPermissions),
    };
};
